






























import AddButton from '@/shared/buttons/add-button.component.vue';
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import Rules from '../rules/rules';

@Component({
  components: {
    AddButton,
  },
})
export default class AutoCompleteAddItemComponent extends Vue {
  @Prop({ type: String, default: '' }) label!: string;

  @Prop({ type: Boolean, required: false, default: false }) loading!: boolean;

  @Prop({ type: Boolean, default: true }) disabled!: boolean;

  @Prop({ type: Boolean, required: false, default: false }) readonly!: boolean;

  @Prop({ type: Boolean, default: true }) editModeValue!: boolean;

  @Prop({ type: Array, required: true }) allItems !: any[];

  @Prop({ type: [Object, Array], required: false }) element : any;

  @Prop({ required: false, default: () => [] }) rules!: Rules;

  @Prop({ type: Boolean, default: true }) showAddButton!: boolean;

  @Prop({ type: Boolean, default: false }) addElementToAutocomplete!: boolean;

  @Prop({ type: String, default: '' }) noDataText!: string;

  @Prop({ type: Boolean, default: false }) chips!: boolean;

  @Prop({ type: Boolean, default: false }) closableChips!: boolean;

  @Prop({ type: Boolean, default: false }) multiple!: boolean;

  @Prop({ type: String, required: false, default: 'name' }) itemText!: string;

  @Prop({ type: String, required: false, default: 'id' }) itemValue!: string;

  newElementName: string = '';

  handleAddElementToAutocomplete() {
    this.addElementToAutocomplete = true;
    this.$emit('addElementToAutocomplete', {
      elementName: this.newElementName,
      addElement: this.addElementToAutocomplete,
    });
  }

  changedValue(): void {
    this.$emit('change', this.element);
  }
}
